"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExpectedFormat = exports.rowDataToCsv = void 0;
const _ = __importStar(require("lodash"));
const common_1 = require("@finley-technologies/common");
const _untypedRowDataToCsv = (data, fallbackHeaders) => {
    if (data.length) {
        return common_1.csvConversion.csvArrayToFinleyBuffer({
            csvArray: data,
            delimiter: ',',
            quotes: true,
            newline: '\n',
        });
    }
    // If `data` is an empty array, result will be '[]' which is not valid CSV. Since we get header
    // information from the field names of the objects, we need a fake object.
    const fakeRow = _.fromPairs(fallbackHeaders.map((x) => [x, x]));
    const fakeCsv = common_1.csvConversion.arrayToCsvString({
        csvArray: [fakeRow],
        header: true,
        delimiter: ',',
        quotes: true,
        newline: '\n',
    });
    // Keep only the header row, discarding the fake entry.
    const outputBuffer = fakeCsv.split('\n')[0];
    return common_1.finleyBuffer.fromString(outputBuffer);
};
const rowDataToCsv = (data, tapeDefinition) => {
    return _untypedRowDataToCsv(data, tapeDefinition.baseFields.map(({ field }) => field));
};
exports.rowDataToCsv = rowDataToCsv;
const getExpectedFormat = (baseFieldConfig) => {
    switch (baseFieldConfig.type) {
        case 'date':
        case 'optionalDate':
            return baseFieldConfig.externalDateFormat;
        // dateTimes resolve to iso dates
        case 'dateTime':
        case 'optionalDateTime':
            return baseFieldConfig.externalDateTimeFormat;
        default:
            return undefined;
    }
};
exports.getExpectedFormat = getExpectedFormat;
//# sourceMappingURL=utils.js.map